import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SaveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"save"}/>
}
